<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-28 10:25:40
-->
<template>
  <div class="component--empty-layout full flex-col">
    <HeaderPart :is-show-menu="false" :exitable="false" size="small" :is-show-logo="true">
      <template slot="title-append">
        <el-divider direction="vertical"></el-divider>
        <span style="font-weight: 100" :title="catFileName">{{
          catFileName
        }}</span>
      </template>
      <el-alert
        slot="menu-prefix"
        v-if="catReadonly"
        show-icon
        :closable="false"
        type="warning"
        style="line-height: 1; display: inline; margin-right: 12px"
        :title="catReadonlyMessage"
      ></el-alert>
      <el-popover slot="menu-prefix" trigger="hover">
        <span
          slot="reference"
          class="clickable btn_close qa__popover-refrence--icon relative"
          style="line-height: 60px; font-size: 18px; z-index: 1"
        >
          <svg-icon icon="ask" class="question-icon"></svg-icon>
        </span>
        <CatLegend></CatLegend>
      </el-popover>
      <span
        class="clickable btn_close"
        slot="menu-append"
        style="
          line-height: 60px;
          color: #eaecee;
          font-size: 16px;
          margin-right: 20px;
        "
        @click="closeAndGotoParent"
        title="关闭"
      >
        <fa-icon icon="times"></fa-icon>
      </span>
    </HeaderPart>

    <!-- 页面容器 -->
    <div class="innerContent container body-content flex-col flex-expend">
      <router-view class="page-container"></router-view>
    </div>
  </div>
</template>

<script>
import HeaderPart from "./components/Header";
import FootPart from "./components/Foot";
import CatLegend from "../editor/components/catLegend.vue";
import { mapGetters } from "vuex";
import { closeAndGotoParent } from "./components/data";

export default {
  components: {
    HeaderPart,
    FootPart,
    CatLegend,
  },
  methods: {
    closeAndGotoParent,
  },
  computed: {
    ...mapGetters(["catFileName", "catReadonly", "catReadonlyMessage"]),
  },
  mounted() {},
};
</script>

<style lang="scss">
.component--empty-layout {
  background-color: #e5e5e5;
  overflow: hidden;
  min-width: 1200px;

  .innerContent {
    position: relative;
    overflow-y: hidden;
  }

  .page-container {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: 0.2s;
  }

  .btn_close:hover {
    opacity: 0.7;
  }

  .question-icon {
    border-radius: 100%;
    background: white;
    color: #e6a23c;
    vertical-align: text-top;
  }
}
</style>
